<template>
  <div class="contain">
    <h2>Change Password</h2>
    <div class="row">
    <div class="container">
      <div class="col-md-offset-4 col-md-4 col-xs-12">
        <form>
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Email Address" v-model="email">
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Current password" v-model="currentPassword">
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="New password" v-model="newPassword">
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Retype new password" v-model="confirmPassword">
          </div>
          <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="custom-select">
                    <select class="form-control"  v-model="userType" :required = true>
                      <option disabled value="">Select User Type</option>
                      <option>Staff</option>
                      <option>Bulk Data Sales Client</option>
                      <option>All Others</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          <button type="button" v-on:click="changePass" class="btn btn-default submit-btn">Submit</button>

          <p v-if="newPassword !== confirmPassword && confirmPassword.length > 0" class="invalid-pass">New password does not match both fields.</p>
          <p v-if="success === true" class="success-change">Password changed successfully, redirecting to login momentarily.</p>
          <p v-if="success === false" class="invalid-pass">Unable to update password. Please check that the user, password, and user type are correct.</p>
        </form>
        <div v-if="loading" class="fa-3x">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      </div>
      </div>
  </div>
  </div>
</template>


<script>

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      currentPassword: null,
      newPassword: '',
      confirmPassword: '',
      loading: false,
      userType: '',
      success: null
    }
  },
  methods: {
    async changePass() {

    this.loading = true;

	  let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};

    if (this.userType === 'Bulk Data Sales Client'){
       headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/change_password`;
    }else{
       headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/change_password`;
    }
	 
    let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: 'POST',
            headers: headers,
			credentials: 'include',
            body: JSON.stringify({
              email: this.email,
              password: this.currentPassword,
              new_password: this.newPassword
            })
        })
     
      response = await response.json();

      this.loading = false;

      if (response.success === false) {
		  if ( response.status == 403 ) {
			  response = await response.json();
			  alert(response.message);
			  window.location.href = '/login';
		  }
		  else {
        this.success = false;
		  }

      } else if (response.success) {
          this.success = true;

		  fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/logout`, {
  			  method: 'POST',
  			  headers: {
  				'Accept': 'application/json',
  				'Content-Type': 'application/json'
  			  },
  			  credentials: 'include',
  			  body: JSON.stringify({})
  		  })
  		  .then((response) => {
  			  // store
  			  return response.json();
  		  })
  		  .then((response) => {
              if ( response.success ) {
  				// delete xsrf token as well
  				document.cookie = "xsrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
  			}
  		});
		setTimeout(() => {
			this.$router.push({ path: '/login' });
		}, 3000)
      }

    }
  }
}

</script>

<style scoped>

.contain {
  margin-top: 100px;
}
h2 {
  text-align: center;
}

form {
  margin-top: 25px;
}

.invalid-pass {
  color: red;
  margin-top: 10px;
}

.success-change {
    margin-top: 10px;
}

.submit-btn {
  width: 100%;
  background-color: #3498DB;
  color: white;
  font-weight: 600;
}

</style>
